<template>
  <div>
    <div class="workOrder_info">
      <div class="center" v-show="info.state == 5 || info.state == 3 ? true : false">
        <el-steps :active="5" align-center>
          <el-step
            title="建单"
            :description="info.createTime"
            icon="el-icon-add-location"
          ></el-step>
          <el-step
            title="响应时间"
            :description="responseTime"
            icon="el-icon-time"
            style="color: red"
          ></el-step>
          <el-step
            title="处理"
            :description="info.receiveTime"
            icon="el-icon-refresh-right"
          ></el-step>
          <el-step
            title="处理时间"
            :description="handlingTime"
            icon="el-icon-time"
          ></el-step>
          <el-step
            title="完成"
            :description="info.finishTime"
            icon="el-icon-circle-check"
          ></el-step>
        </el-steps>
        <!--  <p class="elp elp1">{{ responseTime }}</p>
        <p class="elp elp2">{{ handlingTime }}</p> -->
      </div>
      <div class="right" style="margin-right: 10px">
        <h1 class="common_color1" v-if="info.state === 1">已申请</h1>
        <h1 class="common_color2" v-if="info.state === 2">派送中</h1>
        <h1 class="common_color3" v-if="info.state === 5 || info.state === 3">
          {{ handlingTime2 }}
        </h1>
      </div>
    </div>
    <el-divider class="divider"></el-divider>
    <div class="bottom">
      <div class="Bleft">
        <Form ref="formDynamic" :model="formDynamic" :label-width="80">
          <List border size="small">
            <ListItem>
              <Col span="3">领用科室:</Col>
              <Col span="19">{{ info.desk }}-{{ info.address }}</Col>
            </ListItem>
            <ListItem>
              <Col span="3"> 设备信息:</Col>
              <Col span="19">
                {{ info.facilityName == null ? "无" : info.facilityName }}
              </Col>
            </ListItem>
            <ListItem>
              <Col span="3">领用人:</Col>
              <Col span="19">{{ info.receive }}</Col>
            </ListItem>
          </List>
          <!-- 表格 -->
          <h4 style="margin: 10px 0">明细:</h4>
          <Row :gutter="5">
            <Col span="24">
              <Table
                :columns="tableCols"
                :data="tabledata"
                :table="table"
                :border="table.border"
                :stripe="table.stripe"
                :header="table.header"
                :footer="table.footer"
                :columns-list="tableCols"
              >
              </Table
            ></Col>
          </Row>
        </Form>
      </div>
      <div class="Bright">
        <el-timeline>
          <!-- 待处理 -->
          <div v-if="info.state === 1">
            <el-timeline-item
              v-show="info.receiveType == 2 && wuliulist != null ? true : false"
              :timestamp="info.createTime"
              placement="top"
              color="#11d169"
              size="large"
              icon="el-icon-circle-check"
            >
              <el-card>
                <div style="display: flex">
                  <el-avatar
                    style="margin-right: 10px"
                    shape="circle"
                    :size="50"
                    src="../../../assets/img/useravatar.jpg"
                    @error="errorHandler"
                  >
                    <img src="../../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div style="width: 80%">
                    <h3>已发货</h3>
                    <p style="height: 10px"></p>
                    <div v-for="item in wuliulist" :value="item.id" :key="item.id">
                      <p v-show="item.logisticsType == 1 ? true : false">
                        公司派送:工程师{{ item.deliverer }}为您派送,联系电话:{{
                          item.delivererPhone
                        }},预计送达时间:{{ item.deliveryTime }}
                      </p>
                      <p v-show="item.logisticsType != 1 ? true : false">
                        物流派送:{{ item.logisticsName }},快递单号:{{ item.logisticsNo }}
                      </p>
                    </div>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item
              v-show="info.receiveType == 2 ? true : false"
              :timestamp="info.createTime"
              placement="top"
              color="#11d169"
              size="large"
              icon="el-icon-circle-check"
            >
              <el-card>
                <div style="display: flex">
                  <el-avatar
                    style="margin-right: 10px"
                    shape="circle"
                    :size="50"
                    :src="
                      caigouren.purchaseName
                        ? caigouren.purchaseAvatar
                        : '../../../assets/img/useravatar.jpg'
                    "
                    @error="errorHandler"
                  >
                    <img src="../../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div style="width: 80%">
                    <h3>货物采购中</h3>
                    <div v-show="caigouren.purchaseName ? true : false">
                      <p>采购时间:{{ caigouren.purchaseTime }}</p>
                      <p style="height: 10px"></p>
                      <p>{{ caigouren.purchaseName }}正在发起采购</p>
                    </div>
                    <p v-show="caigouren.purchaseName ? false : true">暂无采购信息</p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item
              :timestamp="info.createTime"
              placement="top"
              color="#11d169"
              icon="el-icon-circle-check"
            >
              <el-card>
                <div style="display: flex">
                  <el-avatar
                    style="margin-right: 10px"
                    shape="circle"
                    :size="50"
                    :src="
                      info.approveAvatar
                        ? info.approveAvatar.includes('http')
                          ? info.approveAvatar
                          : IMAGE_HOST + info.approveAvatar
                        : info.approveAvatar
                    "
                    @error="errorHandler"
                  >
                    <img src="../../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>{{ info.approveName }}审核通过</h3>
                    <p>审核时间: {{ info.createTime }}</p>
                    <p style="height: 10px"></p>
                    <p v-show="info.maintainerName == null ? false : true">
                      指派接单: {{ info.maintainerName }}
                    </p>
                    <div
                      v-show="Transferlist != []"
                      v-for="(item, index) in Transferlist"
                      :key="index"
                    >
                      <p>
                        {{ item.originalMaintainerName }}转派订单给{{
                          item.maintainerName
                        }},状态:{{
                          info.state == 1
                            ? "待接单"
                            : info.state == 2
                            ? "已拒绝"
                            : info.state == 3
                            ? "已接单"
                            : "暂无状态"
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item
              :timestamp="info.receiveTime"
              placement="top"
              color="#11d169"
              icon="el-icon-circle-check"
            >
              <el-card>
                <div style="display: flex">
                  <el-avatar
                    style="margin-right: 10px"
                    shape="circle"
                    :size="50"
                    :src="
                      info.receiveAvatar
                        ? info.receiveAvatar.includes('http')
                          ? info.receiveImg
                          : IMAGE_HOST + info.receiveAvatar
                        : info.receiveAvatar
                    "
                    @error="errorHandler"
                  >
                    <img src="../../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>{{ info.receive }}提交申请</h3>
                    <p>申请时间: {{ info.receiveTime }}</p>
                    <p style="height: 10px"></p>
                    <p v-show="info.approveName == null ? false : true">
                      指派审核人: {{ info.approveName }}
                    </p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
          </div>

          <!-- 处理中 -->
          <div v-if="info.state === 2">
            <el-timeline-item
              :timestamp="info.deliveryTime"
              placement="top"
              size="large"
              color="#fe7a24"
              icon="el-icon-more-outline"
            >
              <el-card>
                <div style="display: flex">
                  <el-avatar
                    style="margin-right: 10px"
                    shape="circle"
                    :size="50"
                    :src="
                      info.maintainerAvatar
                        ? info.maintainerAvatar.includes('http')
                          ? info.maintainerAvatar
                          : IMAGE_HOST + info.maintainerAvatar
                        : info.maintainerAvatar
                    "
                    @error="errorHandler"
                  >
                    <img src="../../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>货物派送中...</h3>
                    <p>接单时间: {{ info.deliveryTime }}</p>
                    <p style="height: 10px"></p>
                    <p>{{ maintainerName }}开始派送,预计送达时间{{ info.et }}</p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item
              v-show="info.receiveType == 2 && wuliulist != null ? true : false"
              :timestamp="info.createTime"
              placement="top"
              color="#11d169"
              size="large"
              icon="el-icon-circle-check"
            >
              <el-card>
                <div style="display: flex">
                  <el-avatar
                    style="margin-right: 10px"
                    shape="circle"
                    :size="50"
                    src="../../../assets/img/useravatar.jpg"
                    @error="errorHandler"
                  >
                    <img src="../../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div style="width: 80%">
                    <h3>已发货</h3>
                    <p style="height: 10px"></p>
                    <div v-for="item in wuliulist" :value="item.id" :key="item.id">
                      <p v-show="item.logisticsType == 1 ? true : false">
                        公司派送:工程师{{ item.deliverer }}为您派送,联系电话:{{
                          item.delivererPhone
                        }},预计送达时间:{{ item.deliveryTime }}
                      </p>
                      <p v-show="item.logisticsType != 1 ? true : false">
                        物流派送:{{ item.logisticsName }},快递单号:{{ item.logisticsNo }}
                      </p>
                    </div>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item
              v-show="info.receiveType == 2 ? true : false"
              :timestamp="caigouren.purchaseTime"
              placement="top"
              color="#11d169"
              size="large"
              icon="el-icon-circle-check"
            >
              <el-card>
                <div style="display: flex">
                  <el-avatar
                    style="margin-right: 10px"
                    shape="circle"
                    :size="50"
                    :src="
                      caigouren.purchaseName
                        ? caigouren.purchaseAvatar
                        : '../../../assets/img/useravatar.jpg'
                    "
                    @error="errorHandler"
                  >
                    <img src="../../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div style="width: 80%">
                    <h3>货物采购中</h3>
                    <div v-show="caigouren.purchaseName ? true : false">
                      <p>采购时间:{{ caigouren.purchaseTime }}</p>
                      <p style="height: 10px"></p>
                      <p>{{ caigouren.purchaseName }}正在发起采购</p>
                    </div>
                    <p v-show="caigouren.purchaseName ? false : true">暂无采购信息</p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item
              :timestamp="info.createTime"
              placement="top"
              size="large"
              color="#11d169"
              icon="el-icon-circle-check"
            >
              <el-card>
                <div style="display: flex">
                  <el-avatar
                    style="margin-right: 10px"
                    shape="circle"
                    :size="50"
                    :src="src"
                    @error="errorHandler"
                  >
                    <img src="../../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>{{ info.approveName }}审核通过</h3>
                    <p>审核时间: {{ info.createTime }}</p>
                    <p style="height: 10px"></p>
                    <p v-show="info.maintainerName == null ? false : true">
                      指派接单: {{ info.maintainerName }}
                    </p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item
              :timestamp="info.receiveTime"
              placement="top"
              size="large"
              color="#11d169"
              icon="el-icon-circle-check"
            >
              <el-card>
                <div style="display: flex">
                  <el-avatar
                    style="margin-right: 10px"
                    shape="circle"
                    :size="50"
                    :src="
                      info.receiveAvatar
                        ? info.receiveAvatar.includes('http')
                          ? info.receiveAvatar
                          : IMAGE_HOST + info.receiveAvatar
                        : info.receiveAvatar
                    "
                    @error="errorHandler"
                  >
                    <img src="../../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>{{ info.receive }}提交申请</h3>
                    <p>申请时间: {{ info.receiveTime }}</p>
                    <p style="height: 10px"></p>
                    <p v-show="info.approveName == null ? false : true">
                      指派审核人: {{ info.approveName }}
                    </p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
          </div>

          <!-- 已完成 -->
          <div v-if="info.state === 3">
            <el-timeline-item
              :timestamp="info.finishTime"
              placement="top"
              size="large"
              color="#11d169"
              icon="el-icon-circle-check"
            >
              <el-card>
                <div style="display: flex">
                  <el-avatar
                    style="margin-right: 10px"
                    shape="circle"
                    :size="50"
                    :src="
                      info.maintainerAvatar
                        ? info.maintainerAvatar.includes('http')
                          ? info.maintainerAvatar
                          : IMAGE_HOST + info.maintainerAvatar
                        : info.maintainerAvatar
                    "
                    @error="errorHandler"
                  >
                    <img src="../../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>货物派送完成</h3>
                    <p>完成时间: {{ info.finishTime }}</p>
                    <p style="height: 10px"></p>
                    <p>{{ info.maintainerName }}已派送完成</p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item
              :timestamp="info.deliveryTime"
              placement="top"
              size="large"
              color="#11d169"
              icon="el-icon-circle-check"
            >
              <el-card>
                <div style="display: flex">
                  <el-avatar
                    style="margin-right: 10px"
                    shape="circle"
                    :size="50"
                    :src="
                      info.maintainerAvatar
                        ? info.maintainerAvatar.includes('http')
                          ? info.maintainerAvatar
                          : IMAGE_HOST + info.maintainerAvatar
                        : info.maintainerAvatar
                    "
                    @error="errorHandler"
                  >
                    <img src="../../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>货物派送中...</h3>
                    <p>接单时间: {{ info.deliveryTime }}</p>
                    <p style="height: 10px"></p>
                    <p>{{ maintainerName }}开始派送,预计送达时间{{ info.et }}</p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item
              v-show="info.receiveType == 2 ? true : false"
              :timestamp="info.createTime"
              placement="top"
              color="#11d169"
              size="large"
              icon="el-icon-circle-check"
            >
              <el-card>
                <div style="display: flex">
                  <el-avatar
                    style="margin-right: 10px"
                    shape="circle"
                    :size="50"
                    src="../../../assets/img/useravatar.jpg"
                    @error="errorHandler"
                  >
                    <img src="../../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div style="width: 80%">
                    <h3>已发货</h3>
                    <p style="height: 10px"></p>
                    <div v-for="item in wuliulist" :value="item.id" :key="item.id">
                      <p v-show="item.logisticsType == 1 ? true : false">
                        公司派送:工程师{{ item.deliverer }}为您派送,联系电话:{{
                          item.delivererPhone
                        }},预计送达时间:{{ item.deliveryTime }}
                      </p>
                      <p v-show="item.logisticsType != 1 ? true : false">
                        物流派送:{{ item.logisticsName }},快递单号:{{ item.logisticsNo }}
                      </p>
                    </div>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item
              v-show="info.receiveType == 2 && wuliulist != null ? true : false"
              :timestamp="caigouren.purchaseTime"
              placement="top"
              color="#11d169"
              size="large"
              icon="el-icon-circle-check"
            >
              <el-card>
                <div style="display: flex">
                  <el-avatar
                    style="margin-right: 10px"
                    shape="circle"
                    :size="50"
                    :src="
                      caigouren.purchaseName
                        ? caigouren.purchaseAvatar
                        : '../../../assets/img/useravatar.jpg'
                    "
                    @error="errorHandler"
                  >
                    <img src="../../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div style="width: 80%">
                    <h3>货物采购中</h3>
                    <div v-show="caigouren.purchaseName ? true : false">
                      <p>采购时间:{{ caigouren.purchaseTime }}</p>
                      <p style="height: 10px"></p>
                      <p>{{ caigouren.purchaseName }}正在发起采购</p>
                    </div>
                    <p v-show="caigouren.purchaseName ? false : true">暂无采购信息</p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item
              :timestamp="info.createTime"
              placement="top"
              size="large"
              color="#11d169"
              icon="el-icon-circle-check"
            >
              <el-card>
                <div style="display: flex">
                  <el-avatar
                    style="margin-right: 10px"
                    shape="circle"
                    :size="50"
                    :src="
                      info.approveAvatar
                        ? info.approveAvatar.includes('http')
                          ? info.approveAvatar
                          : IMAGE_HOST + info.approveAvatar
                        : info.approveAvatar
                    "
                    @error="errorHandler"
                  >
                    <img src="../../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>{{ info.approveName }}审核通过</h3>
                    <p>审核时间: {{ info.createTime }}</p>
                    <p style="height: 10px"></p>
                    <p v-show="info.maintainerName == null ? false : true">
                      指派接单: {{ info.maintainerName }}
                    </p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item
              :timestamp="info.receiveTime"
              placement="top"
              size="large"
              color="#11d169"
              icon="el-icon-circle-check"
            >
              <el-card>
                <div style="display: flex">
                  <el-avatar
                    style="margin-right: 10px"
                    shape="circle"
                    :size="50"
                    :src="
                      info.receiveAvatar
                        ? info.receiveAvatar.includes('http')
                          ? info.receiveAvatar
                          : IMAGE_HOST + info.receiveAvatar
                        : info.receiveAvatar
                    "
                    @error="errorHandler"
                  >
                    <img src="../../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>{{ info.receive }}提交申请</h3>
                    <p>申请时间: {{ info.receiveTime }}</p>
                    <p style="height: 10px"></p>
                    <p v-show="info.approveName == null ? false : true">
                      指派审核人: {{ info.approveName }}
                    </p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
          </div>

          <!-- 待审核 -->
          <div v-if="info.state === 4">
            <el-timeline-item
              :timestamp="info.receiveTime"
              placement="top"
              size="large"
              color="#409eff"
            >
              <el-card>
                <div style="display: flex">
                  <el-avatar
                    style="margin-right: 10px"
                    shape="circle"
                    :size="50"
                    :src="
                      info.receiveAvatar
                        ? info.receiveAvatar.includes('http')
                          ? info.receiveAvatar
                          : IMAGE_HOST + info.receiveAvatar
                        : info.receiveAvatar
                    "
                    @error="errorHandler"
                  >
                    <img src="../../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>{{ info.receive }}提交申请</h3>
                    <p>申请时间: {{ info.receiveTime }}</p>
                    <p style="height: 10px"></p>
                    <p v-show="info.approveName == null ? false : true">
                      指派审核人: {{ info.approveName }}
                    </p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
          </div>

          <!-- 已收货 -->
          <div v-if="info.state === 5">
            <el-timeline-item
              :timestamp="info.receiptTime"
              placement="top"
              size="large"
              color="#11d169"
              icon="el-icon-circle-check"
            >
              <el-card>
                <div style="display: flex">
                  <el-avatar
                    style="margin-right: 10px"
                    shape="circle"
                    :size="50"
                    :src="
                      info.receiveAvatar
                        ? info.receiveAvatar.includes('http')
                          ? info.receiveAvatar
                          : IMAGE_HOST + info.receiveAvatar
                        : info.receiveAvatar
                    "
                    @error="errorHandler"
                  >
                    <img src="../../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>{{ info.receive }}已收货</h3>
                    <p>收货时间: {{ info.receiptTime }}</p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item
              :timestamp="info.finishTime"
              placement="top"
              size="large"
              color="#11d169"
              icon="el-icon-circle-check"
            >
              <el-card>
                <div style="display: flex">
                  <el-avatar
                    style="margin-right: 10px"
                    shape="circle"
                    :size="50"
                    :src="
                      info.maintainerAvatar
                        ? info.maintainerAvatar.includes('http')
                          ? info.maintainerAvatar
                          : IMAGE_HOST + info.maintainerAvatar
                        : info.maintainerAvatar
                    "
                    @error="errorHandler"
                  >
                    <img src="../../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>货物派送完成</h3>
                    <p>完成时间: {{ info.finishTime }}</p>
                    <p style="height: 10px"></p>
                    <p>{{ info.maintainerName }}已派送完成</p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item
              :timestamp="info.deliveryTime"
              placement="top"
              size="large"
              color="#11d169"
              icon="el-icon-circle-check"
            >
              <el-card>
                <div style="display: flex">
                  <el-avatar
                    style="margin-right: 10px"
                    shape="circle"
                    :size="50"
                    :src="
                      info.maintainerAvatar
                        ? info.maintainerAvatar.includes('http')
                          ? info.maintainerAvatar
                          : IMAGE_HOST + info.maintainerAvatar
                        : info.maintainerAvatar
                    "
                    @error="errorHandler"
                  >
                    <img src="../../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>货物派送中...</h3>
                    <p>接单时间: {{ info.deliveryTime }}</p>
                    <p style="height: 10px"></p>
                    <p>{{ maintainerName }}开始派送,预计送达时间{{ info.et }}</p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item
              v-show="info.receiveType == 2 && wuliulist != null ? true : false"
              :timestamp="info.createTime"
              placement="top"
              color="#11d169"
              size="large"
              icon="el-icon-circle-check"
            >
              <el-card>
                <div style="display: flex">
                  <el-avatar
                    style="margin-right: 10px"
                    shape="circle"
                    :size="50"
                    src="../../../assets/img/useravatar.jpg"
                    @error="errorHandler"
                  >
                    <img src="../../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div style="width: 80%">
                    <h3>已发货</h3>
                    <p style="height: 10px"></p>
                    <div v-for="item in wuliulist" :value="item.id" :key="item.id">
                      <p v-show="item.logisticsType == 1 ? true : false">
                        公司派送:工程师{{ item.deliverer }}为您派送,联系电话:{{
                          item.delivererPhone
                        }},预计送达时间:{{ item.deliveryTime }}
                      </p>
                      <p v-show="item.logisticsType != 1 ? true : false">
                        物流派送:{{ item.logisticsName }},快递单号:{{ item.logisticsNo }}
                      </p>
                    </div>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item
              v-show="info.receiveType == 2 ? true : false"
              :timestamp="caigouren.purchaseTime"
              placement="top"
              color="#11d169"
              size="large"
              icon="el-icon-circle-check"
            >
              <el-card>
                <div style="display: flex">
                  <el-avatar
                    style="margin-right: 10px"
                    shape="circle"
                    :size="50"
                    :src="
                      caigouren.purchaseName
                        ? caigouren.purchaseAvatar
                        : '../../../assets/img/useravatar.jpg'
                    "
                    @error="errorHandler"
                  >
                    <img src="../../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div style="width: 80%">
                    <h3>货物采购中</h3>
                    <div v-show="caigouren.purchaseName ? true : false">
                      <p>采购时间:{{ caigouren.purchaseTime }}</p>
                      <p style="height: 10px"></p>
                      <p>{{ caigouren.purchaseName }}正在发起采购</p>
                    </div>
                    <p v-show="caigouren.purchaseName ? false : true">暂无采购信息</p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item
              :timestamp="info.createTime"
              placement="top"
              size="large"
              color="#11d169"
              icon="el-icon-circle-check"
            >
              <el-card>
                <div style="display: flex">
                  <el-avatar
                    style="margin-right: 10px"
                    shape="circle"
                    :size="50"
                    :src="
                      info.approveAvatar
                        ? info.approveAvatar.includes('http')
                          ? info.approveAvatar
                          : IMAGE_HOST + info.approveAvatar
                        : info.approveAvatar
                    "
                    @error="errorHandler"
                  >
                    <img src="../../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>{{ info.approveName }}审核通过</h3>
                    <p>审核时间: {{ info.createTime }}</p>
                    <p style="height: 10px"></p>
                    <p v-show="info.maintainerName == null ? false : true">
                      指派接单: {{ info.maintainerName }}
                    </p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item
              :timestamp="info.receiveTime"
              placement="top"
              size="large"
              color="#11d169"
              icon="el-icon-circle-check"
            >
              <el-card>
                <div style="display: flex">
                  <el-avatar
                    style="margin-right: 10px"
                    shape="circle"
                    :size="50"
                    :src="
                      info.receiveAvatar
                        ? info.receiveAvatar.includes('http')
                          ? info.receiveAvatar
                          : IMAGE_HOST + info.receiveAvatar
                        : info.receiveAvatar
                    "
                    @error="errorHandler"
                  >
                    <img src="../../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>{{ info.receive }}提交申请</h3>
                    <p>申请时间: {{ info.receiveTime }}</p>
                    <p style="height: 10px"></p>
                    <p v-show="info.approveName == null ? false : true">
                      指派审核人: {{ info.approveName }}
                    </p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
          </div>
        </el-timeline>
      </div>
    </div>
  </div>
</template>
<script>
import { IMAGE_HOST } from "@/../config";
export default {
  name: "orderInfo",
  components: {},
  props: {
    kv: null,
    workId: {
      type: String,
      value: "",
    },
    callId: {
      type: String,
      value: "",
    },
  },
  data() {
    return {
      src: "../../../assets/img/useravatar.jpg",
      wuliulist: [],
      IMAGE_HOST: IMAGE_HOST,
      text: "",
      mname: "inventory",
      Transferlist: [],
      info: {},
      list: [],
      id: "",
      tabledata: [],
      total: this.total,
      sysConsumableReceiveDetailsT: [],
      maintainerName: "",
      responseTime: "", //响应时间
      handlingTime: "", //处理时间
      handlingTime2: "", //总处理时间
      assetNum: "", //设备编号
      facilityNo: "", //系统编号
      assetId: "", //设备ID
      caigouren: {},
      table: {
        mname: "consumables",
        key: "id",
        url: {},
        output: false,
        border: true,
        rows: [],
        stripe: true,
        header: false,
        footer: false,
        order: "",
        router: {
          add: "",
          edit: "",
        },
      },
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 65,
          align: "center",
        },
        {
          title: "货物信息",
          width: 600,
          align: "center",
          render: (h, p) => {
            return h(
              "div",
              {
                style: {
                  height: "80px",
                  display: "flex",
                  justifyContent: "flex-start",
                },
              },
              [
                h("img", {
                  style: {
                    width: "60px",
                    height: "60px",
                    margin: "10px",
                  },
                  attrs: { src: IMAGE_HOST + p.row.consumableImgUrl },
                }),
                h("div", [
                  h(
                    "p",
                    {
                      style: {
                        marginTop: "10px",
                        textAlign: "left",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      },
                      domProps: {
                        title: p.row.brand + p.row.name,
                      },
                    },
                    p.row.brand + p.row.name
                  ),

                  h(
                    "p",
                    {
                      style: {
                        textAlign: "left",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: p.row.model == null ? "none" : "block",
                      },
                      domProps: {
                        title: "型号:" + p.row.model,
                      },
                    },
                    "型  号: " + p.row.model
                  ),
                  h(
                    "p",
                    {
                      style: {
                        width: "400px",
                        textAlign: "left",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: p.row.remark == null ? "none" : "block",
                      },
                      domProps: {
                        title: "适用于: " + p.row.remark,
                      },
                    },
                    "适用于: " + p.row.remark
                  ),
                ]),
              ]
            );
          },
        },
        {
          title: "关联信息",
          width: 150,
          align: "left",
          key: "sysConsumableFacilityList",
          render: (h, params) => {
            const row = params.row.sysConsumableFacilityList;
            console.log(params.row);
            return (
              <div onClick={() => this.RelatesInfo(params.row)} style="cursor: pointer;">
                {row.length > 0 ? (
                  row.map((item) => (
                    <div>
                      {item.facilityNo}/{item.model}
                    </div>
                  ))
                ) : (
                  <div style="width: 10px; height: 20px; background-color: transparent; cursor: pointer;"></div>
                )}
              </div>
            );
          },
        },
        {
          title: "领用数",
          key: "alertNum",
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.unit;
            const num = row.alertNum;
            return (
              <span style={{ "font-size": "14px" }}>
                {num}/{text}
              </span>
            );
          },
        },
      ],
    };
  },
  created() {
    let route = this.$route;
    this.title = route.title || "";
    let query = this.$route.query;
    if (query.kv) {
      this.kv = query.kv;
    }
    if (this.kv) {
      this.initData(this.kv);
    }
    if (this.workId) {
      this.initData(this.workId);
    }
    if (query.callId) {
      this.callId = query.callId;
    }
    if (this.callId) {
      this.initData(this.callId);
    }
    if (query.stateId) {
      this.editInformation(query.stateId);
    }
  },
  methods: {
    async editInformation(id) {
      let d = {
        id: id,
      };
      let res = await $utils.api.load("/admin/system/information", d, "PUT");
      console.log(res);
    },
    errorHandler() {
      return true;
    },
    initData(workId, page = 1) {
      // 加载详情工单数据
      let id = this.kv;
      let callId = this.callId;
      if (callId == null) {
        $utils.api.load(`/admin/system/inventory/${id}`, {}).then((res) => {
          if (res && res.data) {
            this.info = res.data;
            this.maintainerName = res.data.maintainerName;
            this.Transferlist = res.data.sysWorkTransferResponseDtos;
            let list = res.data.sysConsumableFacilityList;
            let arr = res.data.sysConsumableReceiveDetails;
            let wuliu = res.data.sysConsumableReceivePurchaseResponse;
            if (wuliu != null) {
              this.caigouren = {
                purchaseName: wuliu.purchaseName ? wuliu.purchaseName : "",
                purchaseAvatar: wuliu.purchaseAvatar,
                purchaseTime: wuliu.purchaseTime ? wuliu.purchaseTime : "",
              };
            }
            this.wuliulist =
              wuliu == null ? null : wuliu.sysConsumableReceivePurchaseLogisticsList;
            for (let i = 0; i < arr.length; i++) {
              let item = arr[i];
              let obj = {};
              obj.consumableImgUrl = item.consumableImgUrl
                ? item.consumableImgUrl
                : "src\assets\logo.min.png";
              obj.brand = item.brand;
              obj.name = item.inventoryName;
              obj.model = item.model;
              obj.remark = item.remark;
              obj.unit = item.unit;
              obj.alertNum = item.alterNum;
              obj.sysConsumableFacilityList = list;
              this.tabledata.push(obj);
            }
            this.responseTime = this.computingTime(
              this.info.createTime,
              this.info.deliveryTime
            );
            this.handlingTime = this.computingTime(
              this.info.deliveryTime,
              this.info.finishTime
            );
            this.handlingTime2 = this.computingTime(
              this.info.createTime,
              this.info.finishTime
            );
            this.id = this.info.id;
          }
        });
      }
    },
    //计算相差时间
    computingTime(a, b) {
      //a开始时间//b结束时间
      var date3 = new Date(b).getTime() - new Date(a).getTime(); //时间差的毫秒数
      //------------------------------
      //计算出相差天数
      // var days = Math.floor(date3 / (24 * 3600 * 1000));
      //计算出小时数
      var leave1 = date3 % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
      var hours = Math.floor(leave1 / (3600 * 1000));
      //计算相差分钟数
      var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
      var minutes = Math.floor(leave2 / (60 * 1000));
      //计算相差秒数
      var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
      var seconds = Math.round(leave3 / 1000);
      return hours + "时" + minutes + "分" + seconds + "秒";
    },
  },
};
</script>
<style lang="less" scoped>
.consumableClass {
  text-indent: 60px;
}

.workOrder_info {
  width: 100%;
  background: #fff;
  display: flex;
  justify-content: space-between;
  .center {
    width: 80%;

    .elp {
      padding-top: 10px;
      position: fixed;
      top: 110px;
      color: #409eff;
    }

    .elp1 {
      left: 44.875rem;
    }

    .elp2 {
      left: 30.375rem;
    }
  }

  .right {
    color: #000;
    font-size: 13px;
    font-weight: 500;
  }
}

.workOrder_info2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: #fff;
  border-radius: 5px;
  position: relative;
  margin-bottom: 10px;
  padding-left: 18px;
  padding-right: 140px;
  /* .left {
    margin-left: 18px;
  }
  .right {
    position: absolute;
    right: 138px;
  } */
}

.workOrder_content {
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  background: #fff;
  width: 100%;
  border-radius: 5px;

  .title {
    color: #000;
    font-size: 13px;
    font-weight: 600;
  }

  .item_box {
    display: flex;
  }
}

.workOrder_br {
  height: 1px;
  width: 100%;
  background: #f7f7f7;
}

.common_title {
  color: #000;
  font-size: 13px;
  font-weight: 500;
}

.common_image {
  width: 60px;
  height: 60px;
  border-radius: 2px;
  background: #f7f7f7;
}

.common_image_weixiu {
  width: 60px;
  height: 160px;
  border-radius: 2px;
  background: #fff;
  display: flex;
}

.common_color {
  color: #666;
}

.common_color1 {
  color: orange;
  padding-top: 10px;
}

.common_color2 {
  color: blue;
  padding-top: 10px;
}

.common_color3 {
  color: green;
  padding-top: 10px;
}

.bottom {
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
  .Bleft {
    width: 68%;
    .zong {
      margin-top: 10px;
      text-align: right;
    }
  }
  .Bright {
    width: 30%;
  }
}

.divider {
  margin: 0;
}
</style>
